import React from 'react'
import './ListToolbarAddIcon.scss'

interface ListToolbarAddIconProps {
  size?: number
  className?: string
}

/**
 * Das Plus der **Listen-Werkzeug-Pille** (Figma `btn List Toolbar Add Task`
 * 5550:75593, Ebene `Plus`). Zweifarbig in der Farbe des Lebensbereichs
 * (`--space-500` / `--space-50`, Sven 05.10.2026) — anders als Abschnitt, Notiz
 * und Memo, deren Farbe der Sache gehört: Die Aufgabe gehört dem Bereich.
 *
 * Das Kreuz sitzt 0,2px rechts unter der Kreismitte — so liegt es im Entwurf.
 */
export const ListToolbarAddIcon: React.FC<ListToolbarAddIconProps> = ({ size = 24, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={['list-toolbar-add-icon', className].filter(Boolean).join(' ')} aria-hidden="true">
    <circle className="list-toolbar-add-icon__circle" cx="12" cy="12" r="9.6" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="square" />
    <path className="list-toolbar-add-icon__plus" d="M8.2 12.2H16.2M12.2 8.2V16.2" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)
